<ngx-spinner class="custom-spinner"
bdColor="rgba(255,255,255,1)"
  size="medium"
  color="#fff"
  type="ball-atom"
  [fullScreen]="true"
>
<span class="loader">
    <img width="150px"  src="/assets/media/logos/logo-wegestu-color.png" alt="">
</span>
</ngx-spinner>
<div class="app-main flex-column flex-row-fluid" id="kt_app_main">
    <!--begin::Content wrapper-->
    <div class="d-flex flex-column flex-column-fluid">
        <!--begin::Toolbar-->
        <div id="kt_app_toolbar" class="app-toolbar py-3 py-lg-6">
            <!--begin::Toolbar container-->
            <div id="kt_app_toolbar_container" class="app-container container-fluid d-flex flex-stack">
                <!--begin::Page title-->
                <div class="page-title d-flex flex-column justify-content-center flex-wrap me-3">
                    <!--begin::Title-->
                    <div class="d-flex flex-wrap my-1 header-grid align-items-center">
                        <h1 class="page-heading">
                            <svg width="44" height="42" viewBox="0 0 44 42" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <g filter="url(#filter0_d_855_1927)">
                                    <path
                                        d="M18.721 18.1916L20.1507 16.7613C20.5248 16.3873 20.7305 15.8908 20.7305 15.3617C20.7305 14.8327 20.5248 14.3362 20.1507 13.9622C19.4033 13.2147 18.0997 13.2141 17.3516 13.9622L15.791 15.2429C16.2266 15.8081 16.7043 16.3589 17.2292 16.8837C17.71 17.3645 18.2125 17.791 18.721 18.1916Z"
                                        fill="#265D91" />
                                    <path
                                        d="M19.6724 4.38366C17.4488 3.80213 15.5672 4.13874 14.3734 5.33319C13.1795 6.52703 12.8417 8.40919 13.4238 10.6316C13.7623 11.925 14.3951 13.2479 15.2589 14.5117L16.746 13.2931C17.2575 12.7786 17.982 12.4781 18.7524 12.4781C19.5228 12.4781 20.2473 12.7786 20.7914 13.3227C21.3361 13.8674 21.636 14.5919 21.636 15.3617C21.636 16.1315 21.3355 16.8566 20.7914 17.4007L19.4522 18.7399C21.5051 20.1702 23.6713 20.9484 25.5113 20.9484C26.8197 20.9484 27.9635 20.5587 28.7821 19.7407C31.1795 17.3434 29.8975 12.1614 25.9251 8.189C24.0303 6.29417 21.8097 4.94288 19.6724 4.38306V4.38366Z"
                                        fill="#265D91" />
                                    <path
                                        d="M14.9489 26.2933C14.9489 26.1733 14.9013 26.058 14.8162 25.9736L8.14059 19.298C7.96384 19.1212 7.67729 19.1212 7.50054 19.298L4.71893 22.0796C3.76036 23.0382 3.76036 24.5982 4.71893 25.5567L8.55744 29.3953C9.51601 30.3538 11.076 30.3538 12.0346 29.3953L14.8162 26.6136C14.9013 26.5286 14.9489 26.4128 14.9489 26.2933Z"
                                        fill="#265D91" />
                                    <path
                                        d="M39.7465 0.420861C39.729 0.171113 39.5052 -0.0195155 39.2633 0.00159848L37.2014 0.146983C36.9522 0.164477 36.764 0.381046 36.7821 0.63019C36.7996 0.879938 37.0162 1.06574 37.2653 1.04945L38.2571 0.979475L34.6822 4.38545L32.9484 2.98349C32.7729 2.84112 32.5201 2.85017 32.3554 3.004L28.8077 6.30682C28.6249 6.47694 28.6146 6.76348 28.7847 6.94627C28.9555 7.12966 29.242 7.13871 29.4242 6.96919L32.6842 3.93422L34.4216 5.3386C34.5983 5.48157 34.8535 5.47192 35.0182 5.31447L38.9218 1.5948L38.9888 2.54673C39.0057 2.79648 39.2259 2.98469 39.472 2.96599C39.7212 2.9485 39.9094 2.73193 39.8913 2.48279L39.7465 0.420861Z"
                                        fill="#265D91" />
                                    <path
                                        d="M15.7766 26.9334L13.0366 29.6734L16.7949 33.4317C17.5574 34.1996 18.8182 34.1489 19.5349 33.3448C19.889 32.9907 20.0844 32.5189 20.0844 32.0182C20.0844 31.5175 19.889 31.0458 19.5349 30.6917L15.7766 26.9334Z"
                                        fill="#265D91" />
                                    <path
                                        d="M12.549 10.8602C12.4253 10.3878 12.3518 9.93238 12.3023 9.48718L8.11328 17.9991C8.12173 18.0063 16.1088 25.9675 16.1155 26.0007L24.6159 21.8177C21.9743 21.5275 19.0382 19.9718 16.5908 17.5237C14.5844 15.5167 13.1487 13.1501 12.549 10.8602Z"
                                        fill="#265D91" />
                                </g>
                                <defs>
                                    <filter id="filter0_d_855_1927" x="0" y="0" width="43.8926" height="41.9789"
                                        filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                        <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                        <feColorMatrix in="SourceAlpha" type="matrix"
                                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                        <feOffset dy="4" />
                                        <feGaussianBlur stdDeviation="2" />
                                        <feComposite in2="hardAlpha" operator="out" />
                                        <feColorMatrix type="matrix"
                                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
                                        <feBlend mode="normal" in2="BackgroundImageFix"
                                            result="effect1_dropShadow_855_1927" />
                                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_855_1927"
                                            result="shape" />
                                    </filter>
                                </defs>
                            </svg>
                            Historique des vues sur les offres
                        </h1>
                     
                        <!--begin::Menu-->
                    </div>
                    <!--end::Title-->
                    <!--begin::Breadcrumb-->
                    <ul class="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0 pt-1">
                        <!--begin::Item-->
                        <li class="breadcrumb-item text-muted">
                            <a routerLink="/accueil" class="text-muted ">Accueil</a>
                          </li>
                        <!--end::Item-->
                        <!--begin::Item-->
                        <li class="breadcrumb-item">
                          <span class="bullet bg-gray-400 w-5px h-2px"></span>
                        </li>
                        <!--end::Item-->
                        <!--begin::Item-->
                        <li class="breadcrumb-item text-muted"><a class="text-muted" routerLink="/offres-emploi/liste-offres-emploi" > Liste des offres d’emploi                          </a></li>
                        <li class="breadcrumb-item">
                          <span class="bullet bg-gray-400 w-5px h-2px"></span>
                        </li>
                        <li class="breadcrumb-item text-muted">Historique des vues sur les offres</li>
                        <!--end::Item-->
                      </ul>
                    <!--end::Breadcrumb-->
                </div>
                <!--end::Page title-->
                <!--begin::Actions-->

                <!--end::Actions-->
            </div>
            <!--end::Toolbar container-->
        </div>
        <!--end::Toolbar-->
        <div id="kt_app_content" class="app-content flex-column-fluid mb-15">
            <!--begin::Content container-->
            <div id="kt_app_content_container" class="app-container container-fluid">
                <!--begin::Card-->
                <div class="card">
                    <!--begin::Card header-->

                    <div class="card-body tools">
                        <div class="title mb-10">
                            <h4>Recherche</h4>
                        </div>
                        <div class="row mb-3" [formGroup]="searchForm">
                            <div class="col-lg-4">
                                <div class="position-relative d-flex align-items-center mb-3 calenderDate">
                                    <p-calendar [style]="{'border': 'none','margin-top': '-6px'}" dateFormat="dd/mm/yy"
                                    placeholder="Date" inputId="yearpicker" formControlName="date"
                                    class="form-control"></p-calendar>
                                </div>
                            </div>
                            <div class="col-lg-4">
                                <div class="input-shadow mb-3">
                                    <input type="text" name="Nom" id="Nom" class="form-control form-control-solid mb-3"
                                    placeholder="Nom candidat" formControlName="user_name" />
                                </div>
                            </div>
                            <div class="col-lg-4 rechercher">
                                <div class="mb-3 search-btn d-flex justify-content-end">
                                  <div class="align-items-center recherche">
                                    <button type="submit" class="me-5"  (click)="searchCompnies()">
                                      <svg width="15" height="15" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path
                                          d="M19.7235 18.263L16.0223 14.5657C18.8541 11.0421 18.5809 5.83122 15.3515 2.63023C13.6625 0.942973 11.4019 0 8.9923 0C6.58271 0 4.34709 0.942973 2.63307 2.63023C0.943993 4.31749 0 6.5756 0 8.98259C0 11.3895 0.943993 13.6228 2.63307 15.3349C4.32216 17.0222 6.58271 17.9652 8.9923 17.9652C11.0293 17.9652 13.0165 17.2704 14.6063 16.005L18.3076 19.7023C18.5064 19.9008 18.7547 20 19.0032 20C19.2764 20 19.5249 19.9008 19.6987 19.7023C20.0962 19.2805 20.0962 18.6601 19.7235 18.2631L19.7235 18.263ZM15.9973 8.95782C15.9973 10.8189 15.2771 12.5807 13.9603 13.8958C12.6438 15.2109 10.88 15.9306 9.01701 15.9306C7.154 15.9306 5.39017 15.2111 4.0737 13.8958C2.75714 12.5806 2.03667 10.8188 2.03667 8.95782C2.03667 7.09682 2.75697 5.3349 4.0737 4.01985C5.39026 2.70472 7.154 1.98502 9.01701 1.98502C10.88 1.98502 12.6438 2.70454 13.9603 4.01985C15.2771 5.33499 15.9973 7.09682 15.9973 8.95782Z"
                                          fill="white" />
                                      </svg>
                                      Rechercher</button>
                                  </div>
                                  <div class="resett-btn">
                                    <div class="reset-icon cursor-pointer" data-bs-toggle="tooltip" data-bs-placement="top"
                                      title="Réinitialiser">
                                      <a (click)=" reset()"> <img src="/assets/media/icons/reset.png" alt="" width="30px"></a>
                                    </div>
                                  </div>
                                </div>
                              </div>
                        </div>
                    </div>
                </div>
            </div>
 
        </div>
        <div id="kt_app_content" class="app-content flex-column-fluid mb-15">
            <div id="kt_app_content_container" class="app-container container-fluid">
                <div class="card content-table">
                    <div class="d-flex flex-wrap my-1 pt-8 header-grid align-items-center">
                        <div class="section_title">
                            <h1 class="section-heading mt-5">Historique des vues sur les offres</h1>
                        </div>
                        <ul class="nav nav-pills me-5" *ngIf="listCampany && listCampany.length">
                            <li class="nav-item m-0">
                                <a class="btn btn-sm btn-icon btn-light btn-color-muted btn-active-primary  me-3"
                                    data-bs-toggle="tab" href="#kt_project_targets_card_pane">
                                    <i class="ki-duotone ki-element-plus fs-1">
                                        <span class="path1"></span>
                                        <span class="path2"></span>
                                        <span class="path3"></span>
                                        <span class="path4"></span>
                                        <span class="path5"></span>
                                    </i>
                                </a>
                            </li>
                            <li class="nav-item m-0">
                                <a class="btn btn-sm btn-icon btn-light btn-color-muted btn-active-primary active"
                                    data-bs-toggle="tab" href="#kt_project_targets_table_pane">
                                    <i class="ki-duotone ki-row-horizontal fs-2">
                                        <span class="path1"></span>
                                        <span class="path2"></span>
                                    </i>
                                </a>
                            </li>
                        </ul>
                    </div>
                    <div class="card-body p-0">
                        <div class="tab-content  for-web">
                            <div id="kt_project_targets_card_pane" class="tab-pane fade ">
                                <div class="card-body">
                                    <div class="row g-6 g-xl-9 justify-content-center">
                                        <div class="col-md-6 col-xxl-4"  *ngFor="let View of listCampany">
                                            <div class="card pt-5 p-5">
                                                <div class="card-body d-flex flex-center flex-column">
                                                    <div class="symbol symbol-65px symbol-circle mb-5">
                                                        <img [src]="!View.user.image_url ? '/assets/media/icons/avatar.jpg' : url + '/User/file/gallery_users/' + View.user.image_url" alt="image profil" width="50px" height="50px" class="circular-image" />
                                                    </div>
                                                    <span class="job-title title-esn text-center mb-1">
                                                        {{View.user?.first_name ? View.user.first_name :'---'}}  {{View.user?.last_name ? View.user.last_name :'---'}}
                                                    </span>
                                                    <div class="info">
                                                        <div class="type mb-3 mt-3">
                                                          <span>Nombre des vues :</span>
                                                          {{View.views_count ? View.views_count :'---' }}
                                                        </div>
                                                    </div>
                                            </div>
                                            <div class="sep"></div>
                                            <div class="foot p-5">
                                                <div class="plus">
                                                    <a [routerLink]="['/candidats/profilecandidatesn',View.user.uuid]">Voir profil</a>
                                                </div>
                                            </div>
                                    </div>
                                        </div>
                                        <div class="pagination mt-5 pt-5" *ngIf="listCampany && listCampany.length">
                                            <mat-paginator [length]="totalItems" [pageSize]="pageSize"
                                                [showFirstLastButtons]="true" [pageSizeOptions]="pageSizeOptions"
                                                [pageIndex]="currentPage" (page)="onPageChange($event)"
                                                aria-label="Select page">
                                            </mat-paginator>
                                        </div>
                                        <app-empty-state *ngIf="listCampany && !listCampany.length"
                                        [title]="parentItem"></app-empty-state>
                                    </div>
                                </div>
                            </div>
                            <div id="kt_project_targets_table_pane" class="tab-pane fade show active">
                                <div class="content">
                                    <div class="card-body">
                                        <div class="table-responsive" *ngIf="listCampany && listCampany.length">
                                            <table class="table align-middle fs-6 gy-5 style-table"
                                                id="kt_customers_table">
                                                <thead>
                                                    <tr
                                                        class="text-start text-gray-400 fw-bold fs-7 text-uppercase gs-0">
                                                        <th class="min-w-125px">Image</th>
                                                        <th class="min-w-125px">Nom Candidat</th>
                                                        <th class="min-w-125px">email</th>
                                                        <th class="min-w-150px">Date</th>
                                                        <th class="min-w-125px">Nombre des vues </th>
                                                        <th class="min-w-125px">Actions</th>
                                                    </tr>
                                                </thead>
                                                <tbody class="fw-semibold text-gray-600">
                                                    <tr *ngFor="let View of listCampany">
                                                        <td>
                                                            <div class="symbol symbol-65px symbol-circle mb-5">
                                                                <img [src]="!View.user.image_url ? '/assets/media/icons/avatar.jpg' : url + '/User/file/gallery_users/' + View.user.image_url" alt="image profil" width="50px" height="50px" class="circular-image" />
                                                            </div>
                                                        </td>
                                                        <td><span>{{View.user?.first_name ? View.user.first_name :'---'}}  {{View.user?.last_name ? View.user.last_name :'---'}}</span></td>
                                                        <td><span class="color-blue">{{View.user?.email ? View.user.email :'---'}}</span></td>
                                                        <td>
                                                            <span> {{ !View.last_viewed_at ? '---' : View.last_viewed_at.split('
                                                                ')[0].split('-').reverse().join('/') }}</span>
                                                        </td>
            
                                                        <td> {{View.views_count}}</td>
            
                                                        <td>
                                                            <button  [routerLink]="['/candidats/profilecandidatesn',View.user.uuid]" type="button" class="btn btn-details"> Voir profil
                                                            </button>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                        <div class="pagination mt-5 pt-5" *ngIf="listCampany && listCampany.length">
                                            <mat-paginator [length]="totalItems" [pageSize]="pageSize"
                                                [showFirstLastButtons]="true" [pageSizeOptions]="pageSizeOptions"
                                                [pageIndex]="currentPage" (page)="onPageChange($event)"
                                                aria-label="Select page">
                                            </mat-paginator>
                                        </div>
                                        <app-empty-state *ngIf="listCampany && !listCampany.length"
                                        [title]="parentItem"></app-empty-state>
                                    </div>
                                </div>
                            </div> 
                        </div>
                        <div class="tab-content for-mobile">
                             <div id="kt_project_targets_card_pane" class="tab-pane fade show active">
                                  <div class="card-body">
                                    <div class="row g-6 g-xl-9 justify-content-center">
                                        <div class="col-md-6 col-xxl-4"  *ngFor="let View of listCampany">
                                            <div class="card pt-5 p-5">
                                                <div class="card-body d-flex flex-center flex-column">
                                                    <div class="symbol symbol-65px symbol-circle mb-5">
                                                        <img [src]="!View.user.image_url ? '/assets/media/icons/avatar.jpg' : url + '/User/file/gallery_users/' + View.user.image_url" alt="image profil" width="50px" height="50px" class="circular-image" />
                                                    </div>
                                                    <span class="job-title title-esn text-center mb-1">
                                                        {{View.user?.first_name ? View.user.first_name :'---'}}  {{View.user?.last_name ? View.user.last_name :'---'}}
                                                    </span>
                                                    <div class="info">
                                                        <div class="type mb-3 mt-3">
                                                          <span>Nombre des vues :</span>
                                                          {{View.views_count ? View.views_count :'---' }}
                                                        </div>
                                                    </div>
                                            </div>
                                            <div class="sep"></div>
                                            <div class="foot p-5">
                                                <div class="plus">
                                                    <a [routerLink]="['/candidats/profilecandidatesn',View.user.uuid]">Voir profil</a>
                                                </div>
                                            </div>
                                    </div>
                                        </div>
                                        <div class="pagination mt-5 pt-5" *ngIf="listCampany && listCampany.length">
                                            <mat-paginator [length]="totalItems" [pageSize]="pageSize"
                                                [showFirstLastButtons]="true" [pageSizeOptions]="pageSizeOptions"
                                                [pageIndex]="currentPage" (page)="onPageChange($event)"
                                                aria-label="Select page">
                                            </mat-paginator>
                                        </div>
                                        <app-empty-state *ngIf="listCampany && !listCampany.length"
                                        [title]="parentItem"></app-empty-state>
                                    </div>
                                </div>
                             </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
